import { css, type Theme } from "@emotion/react";

export const poweredBy = (theme: Theme) => css`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: ${theme.ds5.spacing.gap.xlarge};
`;

export const poweredByLogo = css`
  height: 14px;
  width: auto;
`;
